// Demographic ID constants
export enum DEMOGRAPHIC_IDS {
  ORGANISATION = "DEM.0000",
  ONSITE = "DEM.0001",
  HYBRID = "DEM.0002",
  REMOTE = "DEM.0003",
  OTHER_WORK_ARRANGEMENT = "DEM.0004",
  TRANSGENDER_FROM_TRANSGENDER_GROUP = "DEM.0010",
  FEMALE = "DEM.0043",
  MALE = "DEM.0044",
  NON_BINARY = "DEM.0046",
  OTHER_GENDER = "DEM.0047",
  TRANSGENDER_FROM_LGBTQ_GROUP = "DEM.0048",
  LGBTQ = "DEM.0051",
  NATIVE_SPEAKERS = "DEM.0070",
  NON_NATIVE_SPEAKERS = "DEM.0071",
  DISABILITY = "DEM.0073",
  NEURODIVERGENT = "DEM.0076",
  NEUROTYPICAL = "DEM.0077",
  NO_DISCLOSURE_NEURODIVERSITY = "DEM.0078",
  AGE_GROUP = "DEM.1200",
  ROLE_GROUP = "DEM.1300",
  MARGINALISED_GROUPS = "DEM.1001",
  MAJORITY_GROUPS = "DEM.1002",
}

export const JOB_RELATIONSHIP_DEMOGRAPHIC_IDS = [
  DEMOGRAPHIC_IDS.ONSITE,
  DEMOGRAPHIC_IDS.HYBRID,
  DEMOGRAPHIC_IDS.REMOTE,
  DEMOGRAPHIC_IDS.OTHER_WORK_ARRANGEMENT,
];

// Demographic Group ID constants
export enum DEMOGRAPHIC_GROUP_IDS {
  ORGANISATION = "DEG.000",
  WORK_ARRANGEMENT = "DEG.001",
  ROLE = "DEG.002",
  AGE = "DEG.008",
  GENDER = "DEG.009",
  TRANSGENDER = "DEG.010",
  LGBTQ = "DEG.011",
  RACE = "DEG.012",
  IMMIGRANT_STATUS = "DEG.013",
  NATIVE_LANGUAGE = "DEG.014",
  DISABILITY = "DEG.015",
  NEURODIVERSITY = "DEG.016",
  MARGINALISED_PEOPLE = "DEG.100",
}

export const BINARY_DEMOGRAPHIC_GROUP_IDS = [
  DEMOGRAPHIC_GROUP_IDS.MARGINALISED_PEOPLE,
  DEMOGRAPHIC_GROUP_IDS.TRANSGENDER,
  DEMOGRAPHIC_GROUP_IDS.GENDER,
  DEMOGRAPHIC_GROUP_IDS.LGBTQ,
  DEMOGRAPHIC_GROUP_IDS.RACE,
  DEMOGRAPHIC_GROUP_IDS.IMMIGRANT_STATUS,
  DEMOGRAPHIC_GROUP_IDS.NATIVE_LANGUAGE,
  DEMOGRAPHIC_GROUP_IDS.DISABILITY,
  DEMOGRAPHIC_GROUP_IDS.NEURODIVERSITY,
];

export interface MajorityMinorityData {
  majorityScore?: number;
  minorityScore?: number;
  majorityCount?: number;
  minorityCount?: number;
  majorityUnderThreshold: boolean;
  minorityUnderThreshold: boolean;
}

export interface ReportDemographic {
  label: string;
  engagement: number;
  engagement_percent: number;
}
